module.exports = __webpack_public_path__ + "img/confirm.233625f5.svg";